import '.a{display:grid;}.ssr-plugin'
import '.ht{grid-template-columns:repeat(3, minmax(250px, 1fr));}.ssr-plugin'
import '.g{gap:1rem;}.ssr-plugin'
import { useTranslations } from '@i18n/useLanguage'
import { BlogCard } from '../../card/BlogCard'
import { pages } from '@app/util/links'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'
import { styled } from 'inlines'
import { StoredImage } from '@app/types/StoredImage'
import { AppearItem, useAppearStyle } from '../blocks/AppearInViewport'

export type NewsContentSectionType = {
  type: 'news'
  title: string
  items: {
    id: number
    slug: string
    title: string
    intro?: string
    images?: StoredImage[]
  }[]
}

const NewsCardItem = ({
  item,
  index,
  meta,
}: {
  item: NewsContentSectionType['items'][number]
  index: number
  meta: string
}) => {
  const appearStyle = useAppearStyle(index + 1)

  return (
    <BlogCard
      title={item.title}
      meta={meta}
      image={item.images?.[0]}
      intro={item.intro}
      to={pages.blog('news', item.slug)}
      style={appearStyle}
    />
  )
}

export const NewsContentSection = ({
  title,
  items,
}: NewsContentSectionType) => {
  const t = useTranslations().app.blogPage

  if (items.length === 0) return null

  return (
    <Column gap="0.5rem" alignItems="stretch">
      <AppearItem staggerIndex={0}>
        <Title.H2>{title}</Title.H2>
      </AppearItem>
      <styled.div className="a ht g"
        style={{
          '@media (max-width: 1200px)': {
            gridTemplateColumns: 'repeat(2, minmax(250px, 1fr))',
          },
          '@media (max-width: 800px)': {
            gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
          },}}
      >
        {items.map((item, index) => (
          <NewsCardItem
            key={item.id}
            item={item}
            index={index}
            meta={t.tabs['news']}
          />
        ))}
      </styled.div>
    </Column>
  )
}
